// extracted by mini-css-extract-plugin
module.exports = {"Returns":"styles_Returns__PlyEp"};